<wvr-header-component
  [logoSrc]="logoSrc"
  [logoHref]="logoHref"
  [logoText]="logoText"
  [logoImgHeight]="logoImgHeight"
  [logoImgWidth]="logoImgWidth"
  [logoImgMargin]="logoImgMargin"
  [headerTitle]="pageTitle"
  [headerTitleUrl]="pageTitleUrl">

  <template top-navigation>
    <wvr-nav-list-component top-navigation aligned="RIGHT">
      <template nav-list-items>
        <ng-container *ngTemplateOutlet="topNavContent"></ng-container>
      </template>
    </wvr-nav-list-component>
  </template>

  <template bottom-navigation>
    <wvr-nav-list-component bottom-navigation *ngIf="!isMobileLayout">
      <template nav-list-items [wvrContentProjection]="eRef" template="nav-list-items"></template>
      <template nav-list-items>
        <ng-container *ngTemplateOutlet="bottomNavContent"></ng-container>
      </template>
    </wvr-nav-list-component>
  </template>

  <template mobile-menu>
    <div *ngIf="isMobileLayout">
      <wvr-nav-list-component [wvrContentProjection]="eRef" template="nav-list-items"></wvr-nav-list-component>
      <ng-container *ngTemplateOutlet="bottomNavContent"></ng-container>
      <wvr-nav-list-component top-navigation-mobile>
        <template nav-list-items>
          <ng-container *ngTemplateOutlet="topNavContent"></ng-container>
        </template>
      </wvr-nav-list-component>
    </div>
  </template>

</wvr-header-component>

<ng-template #topNavContent>
  <wvr-nav-li-component *ngIf="showTopNav('hours')">
    <a href="https://library.tamu.edu/about/hours">
      <wvr-text-component value="Hours"></wvr-text-component>
    </a>
  </wvr-nav-li-component>

  <wvr-nav-li-component *ngIf="showTopNav('libraries')">
    <wvr-dropdown-component class="libraries"
      [btnType]="'link'"
      [btnHref]="'https://library.tamu.edu/about/index'"
      [toggleOn]="'mouseover'"
      [menuXOffset]="'-65px'"
      [menuYOffset]="'45px'"
      [btnFontFamily]="'var(--tl-font-family-sans-serif)'"
      [dropdownMenuDisplay]="'static'">
      <template dropdown-button>
        <wvr-text-component value="Libraries"></wvr-text-component>
      </template>
      <template dropdown-menu>
        <wvre-dropdown-menu-item>
          <div class="libraries-link">
            <a href="//library.tamu.edu/wcl" title="Go to West Campus Library website">
              <wvr-text-component value="West Campus Library"></wvr-text-component>
            </a>
          </div>
          <p>
            <a href="//library.tamu.edu/wcl/about/visit.php" title="Parking Directions for West Campus Library">
              <wvr-text-component value="Parking Directions"></wvr-text-component>
            </a>
            <wvr-text-component value=" / 979-845-2111"></wvr-text-component>
          </p>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <div class="libraries-link"><a href="//cushing.library.tamu.edu" title="Go to Cushing Library website">
            <wvre-text value="Cushing Memorial Library &amp; Archives"></wvre-text>
          </a></div>
          <p>
            <a href="//library.tamu.edu/cushing/visit/directions-parking.php" title="Parking Directions for Cushing Library">
              <wvr-text-component value="Parking Directions"></wvr-text-component>
            </a>
            <wvr-text-component value=" / 979-845-1951"></wvr-text-component>
          </p>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <div class="libraries-link">
            <a href="//library.tamu.edu/galveston/index.php" title="Go to Jack K. Williams Library - Galveston">
              <wvr-text-component value="Jack K. Williams Library - Galveston"></wvr-text-component>
            </a>
          </div>
          <p>
            <a href="//library.tamu.edu/galveston/about/visit.php" title="Parking Directions for Jack K. Williams Library - Galveston">
              <wvr-text-component value="Parking Directions"></wvr-text-component>
            </a>
            <wvr-text-component value=" / 409-740-4560"></wvr-text-component>
          </p>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <div class="libraries-link">
            <a href="//msl.library.tamu.edu" title="Go to Medical Sciences Library website">
              <wvr-text-component value="Medical Sciences Library"></wvr-text-component>
            </a>
          </div>
          <p>
            <a href="//library.tamu.edu/medical-sciences/college-station/visiting.php" title="Parking Directions for Medical Sciences Library">
              <wvr-text-component value="Parking Directions"></wvr-text-component>
            </a>
            <wvr-text-component value=" / 979-845-7428"></wvr-text-component>
          </p>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <div class="libraries-link">
            <a href="//psel.library.tamu.edu" title="Go to Policy Sciences and Economics Library website">
              <wvr-text-component value="Policy Sciences &amp; Economics Library"></wvr-text-component>
            </a>
          </div>
          <p>
            Closed
          </p>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <div class="libraries-link">
            <a href="//library.tamu.edu" title="Go to Evans Library website">
              <wvr-text-component value="Sterling C. Evans Library &amp; Annex"></wvr-text-component>
            </a>
          </div>
          <p>
            <a href="//library.tamu.edu/about/directions/evans-library-annex" title="Parking Directions for Evans Library and Annex">
              <wvr-text-component value="Parking Directions"></wvr-text-component>
            </a>
            <wvr-text-component value=" / 979-845-3731"></wvr-text-component>
          </p>
        </wvre-dropdown-menu-item>
      </template>
    </wvr-dropdown-component>
  </wvr-nav-li-component>

  <wvr-nav-li-component *ngIf="showTopNav('information for')">
    <wvr-dropdown-component class="information-for"
      [btnType]="'link'"
      [btnHref]="'https://library.tamu.edu'"
      [toggleOn]="'mouseover'"
      [menuXOffset]="'-150px'"
      [menuYOffset]="'45px'"
      [btnFontFamily]="'var(--tl-font-family-sans-serif)'"
      [dropdownMenuDisplay]="'static'">
      <template dropdown-button>
        <wvr-text-component value="Information for"></wvr-text-component>
      </template>
      <template dropdown-menu>
        <wvre-dropdown-menu-item>
          <a href="//library.tamu.edu/faculty_info/">
            <wvr-text-component value="Information for Faculty"></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <a href="//library.tamu.edu/grad_info/">
            <wvr-text-component value="Graduate Student Resources"></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <a href="//library.tamu.edu/undergrad_info/">
            <wvr-text-component value="Undergraduate Student Resources"></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <a href="//library.tamu.edu/services/accessibility">
            <wvr-text-component value="Services for Individuals with Disabilities"></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
      </template>
    </wvr-dropdown-component>
  </wvr-nav-li-component>

  <wvr-nav-li-component *ngIf="showTopNav('mylibrary')">
    <a href="https://library.tamu.edu/mylibrary/">
      <wvr-text-component value="MyLibrary"></wvr-text-component>
    </a>
  </wvr-nav-li-component>

  <wvr-nav-li-component *ngIf="showTopNav('help')">
    <wvr-dropdown-component class="help"
      [btnType]="'link'"
      [btnHref]="'https://library.tamu.edu/askus'"
      [toggleOn]="'mouseover'"
      [menuXOffset]="'-365px'"
      [menuYOffset]="'45px'"
      [btnFontFamily]="'var(--tl-font-family-sans-serif)'"
      [dropdownMenuDisplay]="'static'">
      <template dropdown-button>
        <wvr-text-component value="Help"></wvr-text-component>
      </template>
      <template dropdown-menu>
        <wvre-dropdown-menu-item>
          <a href="https://library.tamu.edu/askus">
            <img alt="AskUs logo" height="80px" [src]="askUsSrc">
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <tl-icon-component [set]="'bootstrap'" [name]="'arrow-right-circle'"></tl-icon-component>
          <a href="https://library.tamu.edu/askus" class="helpLink">
            <wvr-text-component value=" Chat with us "></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <tl-icon-component [set]="'bootstrap'" [name]="'arrow-right-circle'"></tl-icon-component>
          <a href="//library.tamu.edu/about/phone" class="helpLink">
            <wvr-text-component value=" Call us "></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <tl-icon-component [set]="'bootstrap'" [name]="'arrow-right-circle'"></tl-icon-component>
          <a href="https://library.tamu.edu/askus/contact-us" class="helpLink">
            <wvr-text-component value=" Email us "></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <tl-icon-component [set]="'bootstrap'" [name]="'arrow-right-circle'"></tl-icon-component>
          <a href="https://askus.library.tamu.edu/ask" class="helpLink">
            <wvr-text-component value=" FAQs "></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
        <wvre-dropdown-menu-item>
          <tl-icon-component [set]="'bootstrap'" [name]="'arrow-right-circle'"></tl-icon-component>
          <a href="https://library.tamu.edu/askus/contact-us" class="helpLink">
            <wvr-text-component value=" Report a problem "></wvr-text-component>
          </a>
        </wvre-dropdown-menu-item>
      </template>
    </wvr-dropdown-component>
  </wvr-nav-li-component>
</ng-template>

<ng-template #bottomNavContent>
  <wvr-nav-li-component class="ml-auto call-to-action" *ngIf="suppressCallToAction !=='true'">
    <a href="https://library.tamu.edu/about/giving/">
      <tl-icon-component [set]="'bootstrap'" [name]="'gift-fill'"></tl-icon-component>
      <wvr-text-component value="Give to the Libraries"></wvr-text-component>
    </a>
  </wvr-nav-li-component>
</ng-template>
